import { render, staticRenderFns } from "./AutoCollectModal.vue?vue&type=template&id=13d7996e&scoped=true"
import script from "./AutoCollectModal.vue?vue&type=script&lang=js"
export * from "./AutoCollectModal.vue?vue&type=script&lang=js"
import style0 from "./AutoCollectModal.vue?vue&type=style&index=0&id=13d7996e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13d7996e",
  null
  
)

export default component.exports